import { render, staticRenderFns } from "./couponManage.vue?vue&type=template&id=243d560e&scoped=true"
import script from "./couponManage.vue?vue&type=script&lang=js"
export * from "./couponManage.vue?vue&type=script&lang=js"
import style0 from "./couponManage.vue?vue&type=style&index=0&id=243d560e&prod&lang=scss"
import style1 from "./couponManage.vue?vue&type=style&index=1&id=243d560e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243d560e",
  null
  
)

export default component.exports